import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import SideBar from '../../Components/Layout/Sidebar';
import { useNavigate } from 'react-router-dom';



const SettingScreen = () => {

    const module = useSelector(state => state.app.module);
    const { userInfo } = useSelector(state => state.auth);
    const navigate = useNavigate();
    useEffect(() => {
        //console.log("module = ", module);

        if(userInfo.role_id != 1){
            navigate('/');
        }

    }, []);



    return (
        <div className="container-fluid" style={{ width: `95%`}}>
            <div className="row">
                <div className="col-sm-2 sidenav" style={{ paddingRight: 0}}>
                    <h4>Admin Menu</h4>
                    <SideBar />
                </div>
                <div className="col-sm-10" style={{ paddingLeft: 0}}>
                    <h4><small>LIST {module}</small></h4>
                    <hr />
                    <div className="" id="main-content-setting">
                        <Outlet />
                    </div>
                </div>
                <div style={{ height: 20 }} />
            </div>
        </div>

    )
}

export default SettingScreen;